/**
 * @voltxampere/ui — W25Q128 SPI Flash (Sprint 45-5, placeholder)
 *
 * PLACEHOLDER. SPI / QSPI flash bus simulation Sprint 47+ engine
 * extension #4 ile aktif olur.
 *
 * Reference: Winbond W25Q128JV — SOIC-8 / WSON-8. Quad-SPI Flash,
 * 128 Mbit (16 MByte), V_DD 2.7-3.6 V, clock 133 MHz, sector 4 KB.
 * ESP32 + STM32 main flash, BIOS/EFI storage, embedded code +
 * filesystem (LittleFS).
 *
 *   Default mapping → digital-gate schemaType:
 *     gateFunction = "NOT"
 *     vHigh = 3.3        (3V flash)
 *     propagationDelay = 50e-9  (50 ns Quad-SPI)
 *
 * Engine zero-diff invariant honored — canonical `digital-gate`
 * engine type via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const memoryW25q128 = {
    id: "w25q128",
    nameTr: "W25Q128 (SPI Flash 128Mbit, SOIC-8, placeholder)",
    nameEn: "W25Q128 (SPI Flash 128Mbit, SOIC-8, placeholder)",
    shortcut: "U",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "W25Q128",
    schemaType: "digital-gate",
    defaultParams: {
        gateFunction: "NOT",
        vHigh: 3.3,
        vLow: 0,
        threshold: 1.65,
        propagationDelay: 50e-9,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=memory-w25q128.js.map